import constantRoutes from '@/router/static';
import { asyncRoutes } from '@/router/permission';

/** 
 * get return roles list
 * 
*/

export function getRolesCodeList(routes) {
    const res = [];
    function fn(routeslist) {
        routeslist.map(route => {
            if (route.views) {
                res.push(route.code);
                fn(route.views);
            } else {
                res.push(route.code);
            }
        });
    }
    fn(routes);
    return res;
}

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */

function hasPermission(roles, route) {
    if (route.meta && route.meta.code) {
        return roles.some(role => route.meta.code == role);
    } else {
        return false;
    }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
    const res = [];
    routes.forEach(route => {
        const tmp = { ...route };
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles);
            }
            res.push(tmp);
        }
    });
    return res;
}
//不递归处理，有二级权限路由三级全返回
export function notFilterChildrenAsyncRoutes(routes, roles) {
    const res = [];
    routes.forEach(route => {
        const tmp = { ...route };
        if (hasPermission(roles, tmp)) {
            const tmpChild = [];
            tmp.children.forEach(child => {
                if (hasPermission(roles, child)) {
                    tmpChild.push(child);
                }
            });
            res.push({
                ...tmp,
                children: tmpChild
            });
        }
    });
    return res;
}

//一层级路由下没有children不显示
export function filterNochildrenRouters(routes) {
    const res = [];
    routes.forEach(r => {
        const tmps = { ...r };
        if (tmps.children && tmps.children.length != 0) {
            res.push(tmps);
        }
    });
    return res;
}

const state = {
    routes: [],
    addRoutes: [],
    btnPermission: [],
    permissionCode: [],
    customerObj: {}
};

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes;
        state.routes = constantRoutes.concat(routes);
    },
    SET_CUSTOMEROBJ: (state, customers = []) => {
        state.customerObj = customers;
    },
    SET_BTNPERMISSION: (state, permission = []) => {
        state.btnPermission = permission;
    },
    SET_PERMISSIONACODE: (state, codeList = []) => {
        state.permissionCode = codeList;
    }

};

const actions = {
    generateRoutes({ commit }, { roles }) {
        return new Promise(resolve => {
            let accessedRoutes;
            const routeCodeList = getRolesCodeList(roles);
            //add fake code to support externalUse route
            routeCodeList.push('externalUse');
            //处理后台无法返回三级路由问题
            // if (routeCodeList.includes('task:timerGroup')) {
            //     routeCodeList.push('task:timerGroupDetial');
            // }
            // accessedRoutes = filterAsyncRoutes(asyncRoutes, routeCodeList);
            accessedRoutes = notFilterChildrenAsyncRoutes(asyncRoutes, routeCodeList);

            accessedRoutes = filterNochildrenRouters(accessedRoutes);

            const lastRoute = {
                path: "*",
                redirect: { name: 'login' },
            };
            accessedRoutes.push(lastRoute);

            commit('SET_PERMISSIONACODE', routeCodeList);
            commit('SET_ROUTES', accessedRoutes);
            resolve(accessedRoutes);
        });
    },

    setBtnPermission({ commit }, permission = []) {
        let permissionCodes = permission.map(v => v.code);
        commit('SET_BTNPERMISSION', permissionCodes);
    },

    setCustomerObj({ commit }, customers) {
        commit('SET_CUSTOMEROBJ', customers);
    }


};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
